module.exports = __webpack_public_path__ + "img/1-block-two-img.cde428b1.png";